import { envConfigs } from '@config/envConfigs';
import { IPagedResultsV1 } from '@gcl/react-core';
import { apiServerGet } from '@common/axios.services';
import { IDesignBriefInfoAttached } from './infoAttached.models';

export const apiRoutes = {
  infoAttachedOptions: '/DesignBriefs/InfoAttached/Options',
};

export const getInfoAttachedOptionsAsync = async (): Promise<IPagedResultsV1<IDesignBriefInfoAttached>> => {
  const result = await apiServerGet<IPagedResultsV1<IDesignBriefInfoAttached>>(
    `${envConfigs.apiBaseUrl}${apiRoutes.infoAttachedOptions}`,
  );
  return result.data;
};
